import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "app/assets/images/logo.svg";
import menu from "app/assets/icons/menu.svg";
import { IoIosClose } from "react-icons/io";

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="relative flex items-center w-full h-20 bg-lightGold 2xl:h-22 mb-6">
      <div className="flex justify-between mx-auto w-internalWidth">
        <Link to="https://www.hejazfs.com.au/">
          <img
            src={logo}
            alt="logo"
            className="w-[58px] sm:w-[80px] h-[30px] sm:h-[42px]"
          />
        </Link>
        <div className="flex items-center gap-3 md:gap-10">
          {/* <button className="hidden md:block bg-gold rounded-[8px] px-3 md:px-6 py-2 md:py-3 text-white font-Mulish transition duration-700 text-[14px]">
            Contact Us
          </button> */}
          <a
            href={`mailto:information@hejazfs.com.au`}
            className="hidden md:block bg-gold rounded-[8px] px-3 md:px-6 py-2 md:py-3 text-white font-Mulish transition duration-700 text-[14px]"
          >
            Contact Us
          </a>

          <img
            src={menu}
            alt="menu"
            className="sm:hidden"
            onClick={toggleSidebar}
          />
        </div>

        {/* Sidebar (Mobile) */}
        <div
          className={`fixed inset-0 bg-white z-50 transform ${
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out`}
        >
          <div className="flex justify-between items-center p-4 bg-lightGold">
            <Link to="/">
              <img src={logo} alt="logo" className="w-[70%]" />
            </Link>

            <button
              onClick={toggleSidebar}
              className="h-9 w-9  text-lightBlue rounded-full flex justify-center items-center"
            >
              <IoIosClose className="text-[35px]" />
            </button>
          </div>
          <ul className="flex flex-col space-y-6 p-6 pt-6">
            <a
              href={`mailto:information@hejazfs.com.au`}
              className="bg-gold rounded-[8px] px-3 md:px-6 py-3 md:py-3 text-white font-Mulish transition duration-700  md:text-base text-sm"
            >
              Contact Us
            </a>
            {/* <button className="bg-gold rounded-[8px] px-3 md:px-6 py-3 md:py-3 text-white font-Mulish transition duration-700  md:text-base text-sm">
              Contact Us
            </button> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
